export default {
  COM: {
    header: "Oops!",
    description: "Sorry, we're down right now. Please try again later.",
    errorText: "Error",
  },
  US: {
    header: "Oops!",
    description: "Sorry, we're down right now. Please try again later.",
    errorText: "Error",
  },
  AU: {
    header: "Oops!",
    description: "Sorry, we're down right now. Please try again later.",
    errorText: "Error",
  },
  ROW: {
    header: "Oops!",
    description: "Sorry, we're down right now. Please try again later.",
    errorText: "Error",
  },
  ROE: {
    header: "Oops!",
    description: "Sorry, we're down right now. Please try again later.",
    errorText: "Error",
  },
  FR: {
    header: "Oups !",
    description:
      "Désolés, nous ne pouvons pas charger cette page pour le moment. Veuillez réessayer plus tard.",
    errorText: "Erreur",
  },
  DE: {
    header: "Oops!",
    description:
      "Leider sind wir gerade nicht verfügbar. Bitte versuche es später noch einmal.",
    errorText: "Fehler",
  },
  ES: {
    header: "¡Uy!",
    description:
      "Lo sentimos, estamos teniendo problemas técnicos. Inténtalo de nuevo más tarde.",
    errorText: "Error",
  },
  IT: {
    header: "Oops!",
    description: "Spiacenti, siamo offline al momento. Riprova più tardi.",
    errorText: "Errore",
  },
  RU: {
    header: "Ой!",
    description:
      "Извините, мы сейчас недоступны. Пожалуйста, повторите попытку позже.",
    errorText: "Ошибка",
  },
  SE: {
    header: "Hoppsan!",
    description: "Tyvärr ligger vi nere just nu. Försök igen senare.",
    errorText: "Fel",
  },
  NL: {
    header: "Oeps!",
    description: "Sorry, we zijn nu even offline. Probeer het later nog eens.",
    errorText: "Error",
  },
  PL: {
    header: "Oops!",
    description:
      "Przykro nam, trwa chwilowa przerwa. Spróbuj ponownie później.",
    errorText: "Error",
  },
  DK: {
    header: "Oeps!",
    description: "Beklager, vores system er nede lige nu. Prøv igen senere.",
    errorText: "Fejl",
  },
};
